"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
function LockUserComponent({ onClick, userProp }) {
    var _a;
    const dispatch = (0, react_redux_1.useDispatch)();
    const { selectedDocument } = (0, react_redux_1.useSelector)((state) => state.documentState);
    const [user, setUser] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (userProp) {
        }
        // Pass user with user_id and restricted flag for backend validation
        if (user) {
            onClick(Object.assign(Object.assign({}, user), { user_id: user._id, restricted: true }));
        }
        else {
            onClick(null); // Clear assignment
        }
    }, [user]);
    (0, react_1.useEffect)(() => {
        if (userProp) {
            setUser(userProp);
        }
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null, (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers) && ((_a = selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers) === null || _a === void 0 ? void 0 : _a.length) > 0 ? (react_1.default.createElement("div", { className: "max-w-2xl mx-auto w-full mt-4" },
        react_1.default.createElement("div", { className: "p-4 max-w-md bg-gray-200 rounded-lg border border-gray-300 sm:p-8" },
            react_1.default.createElement("div", { className: "flex justify-between items-center mb-4" },
                react_1.default.createElement("h3", { className: "text-xl font-bold leading-none text-black" }, "Lock User")),
            react_1.default.createElement("div", { className: "flow-root" },
                react_1.default.createElement("ul", { role: "list", className: "divide-y divide-gray-300" }, (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers) &&
                    (selectedDocument === null || selectedDocument === void 0 ? void 0 : selectedDocument.signers.map((x, index) => (react_1.default.createElement("li", { key: x._id || x.email || `signer_${index}`, onClick: () => {
                            if ((user === null || user === void 0 ? void 0 : user.email) === x.email) {
                                setUser(null);
                            }
                            else {
                                setUser(x);
                            }
                        }, className: `py-3 sm:py-4 cursor-pointer rounded-lg px-2 ${(user === null || user === void 0 ? void 0 : user.email) === x.email ? "bg-primary text-white" : "hover:bg-orange-500/20"}` },
                        react_1.default.createElement("div", { className: "flex items-center space-x-4" },
                            react_1.default.createElement("div", { className: "flex-shrink-0" },
                                react_1.default.createElement("img", { className: "w-8 h-8 rounded-full", src: "https://st3.depositphotos.com/6672868/13701/v/450/depositphotos_137014128-stock-illustration-user-profile-icon.jpg", alt: `${x.first_name} ${x.last_name}` })),
                            react_1.default.createElement("div", { className: "flex-1 min-w-0" },
                                react_1.default.createElement("p", { className: `text-sm font-medium truncate ${(user === null || user === void 0 ? void 0 : user.email) === x.email ? "text-white" : "text-black"}` },
                                    x.first_name,
                                    " ",
                                    x.last_name),
                                react_1.default.createElement("p", { className: `text-sm truncate ${(user === null || user === void 0 ? void 0 : user.email) === x.email ? "text-white/80" : "text-gray-600"}` }, x.email)),
                            (user === null || user === void 0 ? void 0 : user.email) === x.email && (react_1.default.createElement("div", { className: "flex justify-center items-center h-6 w-6 bg-green-500 rounded-full" },
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faCheck, className: "text-white font-bold" }))))))))))))) : (react_1.default.createElement("div", null))));
}
exports.default = LockUserComponent;
